export default __webpack_public_path__ + "static/creating-an-insight-dark-c5eb4a8b9bd58963adcdced52e21d468.mp4";